import { useState } from 'react'
import { Button } from './Button'

export function TournamentJoinCommand({
  tournamentId,
}: {
  tournamentId: string
}) {
  const [copied, setCopied] = useState(false)
  const command = `/torneo entra ${tournamentId}`

  async function copyCommand() {
    try {
      await navigator.clipboard.writeText(command)
      setCopied(true)
      window.setTimeout(() => setCopied(false), 1800)
    } catch {
      setCopied(false)
    }
  }

  return (
    <div className="tournament-command">
      <div className="tournament-command__content">
        <span>Comando per partecipare</span>
        <code>{command}</code>
      </div>

      <Button
        className="button--compact"
        onClick={copyCommand}
        type="button"
        variant="secondary"
      >
        {copied ? 'Copiato' : 'Copia comando'}
      </Button>
    </div>
  )
}
